import { render, staticRenderFns } from "./PhotoStart.vue?vue&type=template&id=9f36ab34&"
import script from "./PhotoStart.vue?vue&type=script&lang=js&"
export * from "./PhotoStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports